import InvestBlockNew from './InvestBlockNew';

export default InvestBlockNew;
